import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './Routes';
import Navigation from './components/Navigation';
import AuthSyncNotification from './user/auth/AuthSyncNotification';
import AutoLogoutNotification from './user/auth/AutoLogoutNotification';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from './user/auth/AuthContext';
import { CompanyProvider } from './context/CompanyContext';
import { WatchlistProvider } from './context/WatchlistContext';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <CompanyProvider>
        <WatchlistProvider>
          <BrowserRouter>
            <Navigation />
            <AppRoutes />
            <AuthSyncNotification />
            <AutoLogoutNotification />
          </BrowserRouter>
        </WatchlistProvider>
      </CompanyProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);